import { Component } from '@angular/core';
import { AppConfig, LayoutService } from './service/app.layout.service';
import { AuthService } from '../services/auth.service';
import { LanguageService } from '../services/language.service';
import { UserService } from '../services/user.service';
import { UnitService } from '../services/unit.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
})
export class AppProfileSidebarComponent {
    languages: { lang: string; code: string }[];
    userInformation: any;
    userRole: string;
    userName: string;
    selectedLanguage: any;
    isDarkthemeMode: boolean = false;
    colorScheme: any;
    selectedUnit: any;
    constructor(
        public layoutService: LayoutService,
        private unitService: UnitService,
        private authService: AuthService,
        private languageProvider: LanguageService,
        private userService: UserService,
        private router: Router
    ) {
        this.userInformation = this.authService.currentUserValue;

        this.unitService
            .getUserName(this.userInformation.uid)
            .subscribe((data: any) => {
                this.userName = data?.name || 'Unknown';
            });

        //   this.authService.getPermissions().subscribe((permissions: any) => {
        //     this.userRole = permissions?.userRole;
        //   });
        this.authService.permission$.subscribe((permissions) => {
            this.userRole = permissions.userRole;
        });

        this.userService.selectedUnit$.subscribe(async (x) => {
            if (!x) return;
            this.selectedUnit = x;
        });

        this.languages = this.languageProvider.getAvailableLanguages();
        this.selectedLanguage = this.languageProvider.currentLanguage;
    }

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }
    signOut() {
        this.authService.logout();
    }

    setLanguage(event) {
        this.languageProvider.setLanguage(event.value);
        this.userService.updateLanguage(event.value);
    }

    toggleDarkMode() {
        this.isDarkthemeMode = !this.isDarkthemeMode;
        this.colorScheme = this.isDarkthemeMode ? 'dim' : 'light';
        const config: AppConfig = {
            ripple: true, //toggles ripple on and off
            inputStyle: 'outlined', //default style for input elements
            menuMode: 'static', //layout mode of the menu, valid values are "static", "overlay", "slim", "horizontal", "reveal" and "drawer"
            colorScheme: this.colorScheme, //color scheme of the template, valid values are "light", "dim" and "dark"
            theme: 'indigo', //default component theme for PrimeNG
            menuTheme: 'colorScheme', //theme of the menu, valid values are "colorScheme", "primaryColor" and "transparent"
            scale: 13, //size of the body font size to scale the whole application
        };
        this.layoutService.config.set(config);
    }

    navigateToMfa() {
        this.router.navigate([
            `/u/${this.selectedUnit.routeName}/settings/mfa`,
        ]);
    }
}
